import { Component, OnInit, QueryList, Renderer2, ViewChild, ViewChildren } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AdministrationService } from 'src/app/components/administration/administration.service';
import { CommonService } from '../../services/common.service';
import { catchError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { GetAllPurityResponseModel } from 'src/app/components/administration/administration.model';
import { SendDataService } from '../../services/send-data.service';
@Component({
  selector: 'app-purity',
  templateUrl: './purity.component.html',
  styleUrls: ['./purity.component.scss']
})
export class PurityComponent extends CommonService implements OnInit {
  @ViewChild('administrationFormData') administrationFormData! : NgForm ;
  getAllPurityData            : any[]=[];
  isAdd                       : boolean = false;

  copyGetAllPurityData          : any[]=[]
  editPurityData                = new GetAllPurityResponseModel();
  
constructor(
  public renderer:Renderer2,
  public administrationService : AdministrationService,
  public toaster: ToastrService,
  public sendDataService : SendDataService,
) 
{
  super(renderer)
}





ngOnInit(): void {
this.getAllPurityList();
}

add(){
  if(!this.sendDataService?.permissionVM?.mastersCanAdd) return; if(!this.sendDataService?.permissionVM?.mastersCanAdd) return;
  this.isAdd = true;
  const obj = {id:0, name:'',active:true}
  this.getAllPurityData?.push(obj);
  this.copyGetAllPurityData?.push(obj);
  setTimeout(()=>{
    const element = document.getElementById(`purityName${obj.id}`);
    element?.focus();
  },0)
}


cancel(){
  // 
  if(this.isAdd)
  {
    this.isAdd = false;
    this.getAllPurityData = this.getAllPurityData.filter((x)=>x.id != 0);
    this.copyGetAllPurityData = this.copyGetAllPurityData.filter((x)=>x.id != 0)
  }
  else if(this.editPurityData?.id && this.editPurityData?.isEdit){
    const index = this.copyGetAllPurityData.findIndex((x)=>x.id == this.editPurityData?.id);
    const singleData =JSON.parse(JSON.stringify(this.copyGetAllPurityData))[index];
    this.getAllPurityData[index] = singleData;
    this.editPurityData = new GetAllPurityResponseModel()
  }  
}


edit(item,formData){
  if(!this.sendDataService?.permissionVM?.mastersCanUpdate) return;
  item.isEdit = true;
  const controlObj = formData?.form?.controls;
  if(controlObj){
    const id = Object.keys(controlObj)[0];
    const element = document.getElementById(id);
    element?.focus();
  }
  this.editPurityData = {...item};
}


checkIsEdit(arr:any[]):boolean{
  return arr?.some((x)=>x.isEdit)
}


  // *********** PURITY API START *********
  // **********get all purity *********
  getAllPurityList() {
     this.administrationService.getAllPurityData=[];
    this.administrationService.getAllPurity().subscribe({
      next:(res)=>{
        if(res.isSuccess){
          this.editPurityData = new GetAllPurityResponseModel();
          this.getAllPurityData = res.response??[];
          this.administrationService.getAllPurityData=JSON.parse(JSON.stringify(this.getAllPurityData.filter((x)=>x.active==true)))??[];
          this.copyGetAllPurityData = JSON.parse(JSON.stringify(this.getAllPurityData))??[];
        }else{           
          this.getAllPurityData = [];
          this.administrationService.getAllPurityData= [];
          this.copyGetAllPurityData = [];
        }  
      },
      error:(err)=>{
        this.getAllPurityData = [];
        this.administrationService.getAllPurityData= []; 
        this.copyGetAllPurityData = [];
      }
    })
  }
  
 // *************insert purity **************
  InserPurityList(item) {
    const {id , ...rest} = item;
    this.administrationService.insertPurity(rest)
        .pipe(catchError((err) => this.handleError(err)))
        .subscribe((res) => {
          if(res.isSuccess){
            this.isAdd = false;
            this.getAllPurityList();
            this.toaster.success(res.message);
          }else{
            this.toaster.error(res.errors[0]);
          }  
      });
    }

  // **********update purity *********
    UpdatePurityList(item) {
    const {isEdit , ...rest} = item;
    this.administrationService.updatePurity(rest)
        .pipe(catchError((err) => this.handleError(err)))
        .subscribe((res) => {
          if(res.isSuccess){
            
            this.isAdd = false;
            this.getAllPurityList();
            this.toaster.success(res.message);
          }else{
            this.toaster.error(res.errors[0]);
          }  
      });
    }  

    // **********delete purity *********
    DeletePurityList(id) {
    if(!this.sendDataService?.permissionVM?.mastersCanDelete) return;
      this.administrationService.deletePurity(id)
          .pipe(catchError((err) => this.handleError(err)))
          .subscribe((res) => {
            if(res.isSuccess){
              this.getAllPurityList();
              this.toaster.success(res.message);
            }else{
              this.toaster.error(res.errors[0]);
            }  
      });
    }
  
  // *********** PURITY API END *********
}
